import React from 'react';

type Props = {
  className?: string;
};

const PPMStoneberryCreditLogo: React.FC<Props> = ({ className = '' }) => (
  <span aria-hidden="true" className={className}>
    <svg
      width="179"
      height="23"
      viewBox="0 0 179 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-full w-full"
    >
      <g clipPath="url(#clip0_477_5613)">
        <path d="M17.0568 11.5034L10.7345 18.2818L4.41272 11.5034L10.7345 4.72559L17.0568 11.5034Z" fill="#113050" />
        <path d="M17.0568 11.5034L17.9103 16.2216L11.5884 23L10.7345 18.2818L17.0568 11.5034Z" fill="#76C6B3" />
        <path
          d="M9.87587 -0.00012207L3.55359 6.77824L4.41235 11.5038L10.7346 4.72547L9.87587 -0.00012207Z"
          fill="#0075C9"
        />
        <path d="M0 12.4241L6.32229 19.2025L10.7347 18.2816L4.41271 11.5038L0 12.4241Z" fill="#F2B5B6" />
        <path d="M10.7348 4.72536L15.1422 3.8103L21.4645 10.5881L17.0571 11.5037L10.7348 4.72536Z" fill="#F8BA17" />
        <mask
          id="mask0_477_5613"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="118"
          height="31"
        >
          <path d="M117.98 0H0V30.5157H117.98V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_477_5613)">
          <path
            d="M29.2029 10.7654L29.0978 10.7453C27.8095 10.5013 26.6964 10.2902 26.6964 9.13667C26.6964 8.03899 27.5395 7.32957 28.845 7.32957C30.0968 7.32957 30.9069 8.00299 30.959 9.08715L30.9639 9.18426H32.8165L32.8132 9.0782C32.7427 6.87599 31.1343 5.39673 28.8108 5.39673C26.4268 5.39673 24.8252 6.92217 24.8252 9.19234C24.8252 11.9668 26.8486 12.3496 28.6338 12.6871L28.7356 12.7063C30.0207 12.95 31.13 13.1606 31.13 14.3165C31.13 15.4716 30.2564 16.161 28.7929 16.161C27.3851 16.161 26.5239 15.4704 26.4902 14.3136L26.4875 14.214H24.5655L24.5679 14.3193C24.6197 16.6116 26.2782 18.0939 28.7929 18.0939C31.3702 18.0939 33.0356 16.5897 33.0356 14.2619C33.036 11.4834 30.9992 11.1022 29.2029 10.7654Z"
            fill="#113050"
          />
        </g>
        <mask
          id="mask1_477_5613"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="118"
          height="31"
        >
          <path d="M117.98 0H0V30.5157H117.98V0Z" fill="white" />
        </mask>
        <g mask="url(#mask1_477_5613)">
          <path
            d="M46.7255 8.33606C44.0286 8.33606 42.0717 10.388 42.0717 13.2151C42.0717 16.0418 44.0286 18.0942 46.7255 18.0942C49.4215 18.0942 51.3789 16.0418 51.3789 13.2151C51.3789 10.3881 49.4217 8.33606 46.7255 8.33606ZM49.542 13.2151C49.542 15.0143 48.3837 16.272 46.7255 16.272C45.067 16.272 43.9086 15.0143 43.9086 13.2151C43.9086 11.4154 45.067 10.1583 46.7255 10.1583C48.3837 10.1583 49.542 11.4154 49.542 13.2151Z"
            fill="#113050"
          />
        </g>
        <mask
          id="mask2_477_5613"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="118"
          height="31"
        >
          <path d="M117.98 0H0V30.5157H117.98V0Z" fill="white" />
        </mask>
        <g mask="url(#mask2_477_5613)">
          <path
            d="M56.7632 8.33606C54.0851 8.33606 52.4865 10.0912 52.4865 13.0309V17.8548H54.3062V13.0309C54.3062 11.2055 55.2018 10.1586 56.7632 10.1586C58.3246 10.1586 59.2203 11.2055 59.2203 13.0309V17.8548H61.0396V13.0309C61.0396 10.0912 59.4413 8.33606 56.7632 8.33606Z"
            fill="#113050"
          />
        </g>
        <mask
          id="mask3_477_5613"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="118"
          height="31"
        >
          <path d="M117.98 0H0V30.5157H117.98V0Z" fill="white" />
        </mask>
        <g mask="url(#mask3_477_5613)">
          <path
            d="M66.8008 8.33594C64.1042 8.33594 62.1474 10.3878 62.1474 13.2154C62.1474 16.042 64.1042 18.0944 66.8008 18.0944C68.7789 18.0944 70.3689 17.0336 71.053 15.2567L71.1079 15.1143H69.1145L69.0856 15.16C68.6084 15.918 67.8825 16.2719 66.8006 16.2719C65.3667 16.2719 64.3303 15.3898 64.0707 13.9608H71.4202V13.2154C71.4204 10.3878 69.478 8.33594 66.8008 8.33594ZM64.1327 12.1937C64.4736 10.916 65.4623 10.1585 66.8008 10.1585C68.1541 10.1585 69.1491 10.9166 69.4865 12.1937H64.1327Z"
            fill="#113050"
          />
        </g>
        <mask
          id="mask4_477_5613"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="118"
          height="31"
        >
          <path d="M117.98 0H0V30.5157H117.98V0Z" fill="white" />
        </mask>
        <g mask="url(#mask4_477_5613)">
          <path
            d="M87.1399 8.33594C84.4434 8.33594 82.4865 10.3878 82.4865 13.2154C82.4865 16.042 84.4434 18.0944 87.1399 18.0944C89.118 18.0944 90.708 17.0336 91.3922 15.2567L91.447 15.1143H89.4534L89.425 15.16C88.9477 15.918 88.2216 16.2719 87.1399 16.2719C85.7061 16.2719 84.6696 15.3898 84.4101 13.9608H91.7595V13.2154C91.7595 10.3878 89.8163 8.33594 87.1399 8.33594ZM84.4718 12.1937C84.8128 10.916 85.8015 10.1585 87.1399 10.1585C88.4932 10.1585 89.4879 10.9166 89.8256 12.1937H84.4718Z"
            fill="#113050"
          />
        </g>
        <mask
          id="mask5_477_5613"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="118"
          height="31"
        >
          <path d="M117.98 0H0V30.5157H117.98V0Z" fill="white" />
        </mask>
        <g mask="url(#mask5_477_5613)">
          <path
            d="M96.6125 8.33606C94.2321 8.33606 92.8672 9.81989 92.8672 12.4065V17.8548H94.6866V12.4063C94.6866 10.9148 95.3343 10.1584 96.6125 10.1584C97.8723 10.1584 98.5382 10.9357 98.5382 12.4063V12.6198H100.341V12.4251C100.341 9.82621 98.9818 8.33606 96.6125 8.33606Z"
            fill="#113050"
          />
        </g>
        <mask
          id="mask6_477_5613"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="118"
          height="31"
        >
          <path d="M117.98 0H0V30.5157H117.98V0Z" fill="white" />
        </mask>
        <g mask="url(#mask6_477_5613)">
          <path
            d="M104.892 8.33606C102.512 8.33606 101.147 9.81989 101.147 12.4065V17.8548H102.966V12.4063C102.966 10.9148 103.614 10.1584 104.892 10.1584C106.152 10.1584 106.818 10.9357 106.818 12.4063V12.6198H108.621V12.4251C108.621 9.82621 107.261 8.33606 104.892 8.33606Z"
            fill="#113050"
          />
        </g>
        <mask
          id="mask7_477_5613"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="118"
          height="31"
        >
          <path d="M117.98 0H0V30.5157H117.98V0Z" fill="white" />
        </mask>
        <g mask="url(#mask7_477_5613)">
          <path
            d="M116.16 8.57495V13.3253C116.16 15.1124 115.241 16.1797 113.703 16.1797C112.141 16.1797 111.246 15.1393 111.246 13.3253V8.57495H109.426V13.3253C109.426 16.7871 111.494 18.0207 113.429 18.0207C114.604 18.0207 115.58 17.4909 116.16 16.5537V18.511C116.16 20.3699 115.345 21.2735 113.669 21.2735C112.452 21.2735 111.679 20.8017 111.307 19.831L111.283 19.7672H109.467L109.498 19.8958C109.975 21.8709 111.495 23.0041 113.669 23.0041C116.408 23.0041 117.98 21.3525 117.98 18.4741V8.57495H116.16Z"
            fill="#113050"
          />
        </g>
        <mask
          id="mask8_477_5613"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="118"
          height="31"
        >
          <path d="M117.98 0H0V30.5157H117.98V0Z" fill="white" />
        </mask>
        <g mask="url(#mask8_477_5613)">
          <path
            d="M77.3322 8.35068C76.0315 8.35068 74.9365 8.92331 74.2755 9.93407V4.47693L72.4558 6.42803V13.1562C72.4558 16.1184 74.3052 18.109 77.0583 18.109C79.8082 18.109 81.7285 16.0799 81.7285 13.1744C81.7285 10.0078 79.5173 8.35068 77.3322 8.35068ZM77.0751 16.2864C75.4271 16.2864 74.2755 15.0297 74.2755 13.2296C74.2755 11.4304 75.4271 10.1731 77.0751 10.1731C78.7336 10.1731 79.8916 11.4302 79.8916 13.2296C79.8916 15.0297 78.7336 16.2864 77.0751 16.2864Z"
            fill="#113050"
          />
        </g>
        <mask
          id="mask9_477_5613"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="118"
          height="31"
        >
          <path d="M117.98 0H0V30.5157H117.98V0Z" fill="white" />
        </mask>
        <g mask="url(#mask9_477_5613)">
          <path
            d="M39.5286 14.3173C39.5286 15.5962 38.9459 16.2717 37.8428 16.2717C36.7511 16.2717 36.1739 15.5962 36.1739 14.3173V10.3787H39.7208V8.57498H36.1739V5.27808L34.3541 7.2297V14.3175C34.3541 16.7176 35.6256 18.0945 37.8426 18.0945C40.0593 18.0945 41.3308 16.7176 41.3308 14.3175V14.0126H39.5284V14.3173H39.5286Z"
            fill="#113050"
          />
        </g>
        <path
          d="M176.815 9.83188C176.815 9.67103 176.843 9.51949 176.901 9.37725C176.958 9.23554 177.037 9.11174 177.135 9.00761C177.234 8.90295 177.35 8.81937 177.483 8.75826C177.615 8.69662 177.757 8.66589 177.907 8.66589C178.057 8.66589 178.199 8.69662 178.331 8.75826C178.464 8.81937 178.58 8.90295 178.679 9.00761C178.778 9.11174 178.856 9.23537 178.913 9.37725C178.971 9.51949 179 9.67103 179 9.83188C179 9.99326 178.971 10.1437 178.913 10.2841C178.856 10.4249 178.778 10.5471 178.679 10.6512C178.58 10.7564 178.464 10.8384 178.331 10.8987C178.199 10.9578 178.057 10.988 177.907 10.988C177.757 10.988 177.615 10.9577 177.483 10.8987C177.35 10.8386 177.235 10.7564 177.135 10.6512C177.037 10.5471 176.958 10.4249 176.901 10.2841C176.843 10.1437 176.815 9.99326 176.815 9.83188ZM176.987 9.83188C176.987 9.96587 177.011 10.0925 177.059 10.2122C177.107 10.332 177.173 10.4375 177.255 10.5281C177.339 10.6191 177.436 10.69 177.548 10.7413C177.66 10.7931 177.78 10.8186 177.908 10.8186C178.035 10.8186 178.155 10.7931 178.267 10.7413C178.379 10.69 178.476 10.6191 178.559 10.5281C178.642 10.4377 178.708 10.3322 178.756 10.2122C178.804 10.0925 178.828 9.96587 178.828 9.83188C178.828 9.69491 178.804 9.5669 178.756 9.44661C178.708 9.32685 178.642 9.2222 178.559 9.13317C178.476 9.04414 178.379 8.97372 178.267 8.92245C178.155 8.87117 178.035 8.84518 177.908 8.84518C177.78 8.84518 177.66 8.87117 177.548 8.92245C177.436 8.97372 177.339 9.04414 177.255 9.13317C177.173 9.2222 177.107 9.32685 177.059 9.44661C177.011 9.5669 176.987 9.69509 176.987 9.83188ZM177.481 9.16952H177.912C177.97 9.16952 178.025 9.17637 178.08 9.18954C178.134 9.20323 178.183 9.22571 178.226 9.25644C178.269 9.2877 178.303 9.32685 178.329 9.37479C178.355 9.42273 178.367 9.48244 178.367 9.55478C178.367 9.65066 178.342 9.7288 178.291 9.78851C178.24 9.84856 178.171 9.88878 178.085 9.90932L178.416 10.4848H178.147L177.859 9.93531H177.701V10.4848H177.481L177.481 9.16952ZM177.878 9.74496C177.942 9.74496 178.003 9.73179 178.06 9.70633C178.118 9.68034 178.147 9.62854 178.147 9.54987C178.147 9.47805 178.12 9.42958 178.068 9.4057C178.015 9.38182 177.96 9.37005 177.902 9.37005H177.701V9.74496H177.878Z"
          fill="#002C4E"
        />
        <path
          d="M123.436 12.0472C123.436 8.48408 125.877 5.86658 129.336 5.86658C132.235 5.86658 134.423 7.70231 135.05 10.4108H132.761C132.235 8.97488 130.981 8.02945 129.336 8.02945C127.132 8.02945 125.64 9.72049 125.64 12.0472C125.64 14.3739 127.132 16.0825 129.336 16.0825C130.981 16.0825 132.235 15.1193 132.761 13.6831H135.05C134.423 16.3921 132.235 18.2278 129.336 18.2278C125.877 18.2278 123.436 15.6098 123.436 12.0472Z"
          fill="#002C4E"
        />
        <path
          d="M136.423 12.7744C136.423 10.0659 137.915 8.77527 140.102 8.77527C142.289 8.77527 143.765 10.0659 143.765 12.8111V12.8654H141.764V12.7744C141.764 11.3199 141.085 10.7929 140.102 10.7929C139.119 10.7929 138.44 11.3199 138.44 12.7744V17.9913H136.423L136.423 12.7744Z"
          fill="#002C4E"
        />
        <path
          d="M151.36 12.5384C151.038 11.3382 150.122 10.7383 149.02 10.7383C147.884 10.7383 147.002 11.3568 146.68 12.5384H151.36ZM144.51 13.5014C144.51 10.7749 146.375 8.77478 149.02 8.77478C151.665 8.77478 153.496 10.7749 153.496 13.5014V14.2651H146.629C146.901 15.5739 147.833 16.2647 149.02 16.2647C149.919 16.2647 150.58 15.9918 151.004 15.41H153.157C152.529 17.1186 151.004 18.2275 149.02 18.2275C146.375 18.2275 144.51 16.228 144.51 13.5014Z"
          fill="#002C4E"
        />
        <path
          d="M161.448 13.5016C161.448 11.9199 160.464 10.7931 158.99 10.7931C157.514 10.7931 156.514 11.9199 156.514 13.5016C156.514 15.0832 157.514 16.21 158.99 16.21C160.464 16.21 161.448 15.0832 161.448 13.5016ZM154.479 13.4106C154.479 10.3385 156.616 8.77491 158.65 8.77491C159.854 8.77491 160.854 9.3205 161.448 10.3204V5.08484H163.465V13.4287C163.465 16.3372 161.635 18.2277 159.006 18.2277C156.345 18.2277 154.479 16.2643 154.479 13.4106Z"
          fill="#002C4E"
        />
        <path
          d="M165.415 9.01144H167.433V17.9915H165.415V9.01144ZM165.093 6.41202C165.093 5.57546 165.652 4.95752 166.432 4.95752C167.212 4.95752 167.771 5.57546 167.771 6.41202C167.771 7.24805 167.212 7.84791 166.432 7.84791C165.652 7.84791 165.093 7.24788 165.093 6.41202Z"
          fill="#002C4E"
        />
        <path
          d="M169.382 14.5376V8.10728L171.4 5.83044V9.01163H175.723V10.9745H171.4V14.5376C171.4 15.7373 171.976 16.21 172.807 16.21C173.638 16.21 174.214 15.7554 174.214 14.5376V14.3009H176.232V14.5376C176.232 17.028 174.842 18.2277 172.807 18.2277C170.772 18.2279 169.382 17.028 169.382 14.5376Z"
          fill="#002C4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_477_5613">
          <rect width="179" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </span>
);

export default PPMStoneberryCreditLogo;
